import React, { useState } from "react";
import SearchBar from "../../components/SearchBar";
import Navbar from "../../components/Navbar";
import hamburger_icon from "../../assets/icons/hamburger_icon.png";

const Language = () => {
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);
  const [edit, setEdit] = useState(false);

  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };
  return (
    <div>
      <div className="flex items-center justify-center w-full">
        <div
          className="items-center justify-center hidden hamburger"
          onClick={toggleNavbar}
        >
          <img
            src={hamburger_icon}
            alt="hamburger"
            className="object-contain"
          />
        </div>
        <div className="flex items-center justify-center w-full">
          <SearchBar categoryName="Profile" />
        </div>
        <div className="absolute top-0 w-[70%] z-20 bg-white rounded-lg mt-16">
          {isNavbarVisible && <Navbar />}
        </div>
      </div>

      <div className="ml-4 mt-10">
        <p className="text-[18px] font-bold">Language</p>
      </div>

      <div className="ml-4 mt-4 p-4 border w-[15rem] rounded-lg">
        <div className="text-[#606060] flex items-center">
          <p className="text-[22px]">English</p>
          <p className="text-[12px] ml-4">Default</p>
        </div>
        <p
          className="text-[#2F80ED] text-[16px] underline mt-9 cursor-pointer"
          onClick={() => setEdit(!edit)}
        >
          Edit
        </p>
      </div>

      {edit ? (
        <div className="mt-4 ml-10 text-[#606060] text-[20px]">
          <div className="flex items-center">
            <input type="checkbox" />
            <p className="ml-2">Hindi</p>
          </div>
          <div className="flex items-center mt-2">
            <input type="checkbox" />
            <p className="ml-2">Gujarati</p>
          </div>
          <div className="flex items-center mt-2">
            <input type="checkbox" />
            <p className="ml-2">Marathi</p>
          </div>
          <div className="flex items-center mt-2">
            <input type="checkbox" />
            <p className="ml-2">Bengali</p>
          </div>
          <div className="flex items-center mt-2">
            <input type="checkbox" />
            <p className="ml-2">Kanada</p>
          </div>
          <div className="flex items-center mt-2">
            <input type="checkbox" />
            <p className="ml-2">Telgu</p>
          </div>
          <div className="flex items-center mt-2">
            <input type="checkbox" />
            <p className="ml-2">Punjabi</p>
          </div>
          <div className="flex items-center mt-2">
            <input type="checkbox" />
            <p className="ml-2">Tamil</p>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default Language;
